function thorttle(fn, gap = 500) {
  let last_run = null;
  return (...arg) => {
    const now = new Date();
    if (!last_run || now - last_run > gap * 1) {
      fn(...arg);
      last_run = new Date();
    }
  };
}

export default {
  bind(el, { arg, value, modifiers }, vnode) {
    const gap =
      modifiers && Object.keys(modifiers).length !== 0
        ? Object.keys(modifiers)[0]
        : 500;
    const t_fn = thorttle(value.bind(vnode), gap);
    el.addEventListener(arg, ev => {
      t_fn(ev);
    });
  }
}
